import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrophy = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-trophy-icon lucide-trophy",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 9h1.5a1 1 0 0 0 0-5H18" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 22h16" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 9H4.5a1 1 0 0 1 0-5H6" })
	]
});
export default SvgTrophy;
